<template>
  <tr class="line-item">
    <td class="text-center">{{ item.id }}</td>
    <td class="text-center">{{ $t(item.type) }}</td>
    <td class="text-center">{{ item.new ? $t('yes') : $t('no') }}</td>
    <td class="text-center">{{ item.start_date ? item.start_date : $t('not_set') }}</td>
    <td class="text-center">{{ item.end_date ? item.end_date : $t('not_set') }}</td>
    <td class="text-center">
      <v-icon @click="open">mdi-pencil</v-icon>
      <v-icon @click="remove">mdi-delete-forever</v-icon>
    </td>
  </tr>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'Banner',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions({
      removeItem: 'settings/landing/banners/delete',
    }),
    open () {
      this.$router.push(`/settings/landing/banners/${this.item.id}`)
    },
    remove () {
      this.removeItem({ item_id: this.item.id })
        .then(() => {
          this.$emit('removed', this.item.id)
        })
    },
  },
}
</script>
<style scoped>
.line-item {
  height: 50px;
}
</style>
